import moment from "moment-timezone";

export default {
  name: "formatDateFromNow",
  fn: utcDateString => {
    return utcDateString && utcDateString.length > 0 ? moment(utcDateString).fromNow() : "";
  }
};
